import {
  buildAmountString,
  buildPairNameByStrategy,
  buildPercentageString,
} from 'components/strategies/portfolio/utils';
import { Token } from 'libs/tokens';
import { useMemo } from 'react';
import { getUsdPrice } from 'utils/helpers';
import { PortfolioTokenData } from './usePortfolioToken';
import { useBreakpoints } from 'hooks/useBreakpoints';
import { Options } from 'libs/charts';
import { getColorByIndex } from 'utils/colorPalettes';

export const usePortfolioTokenPieChart = (
  data: PortfolioTokenData[],
  token?: Token,
) => {
  const { belowBreakpoint } = useBreakpoints();

  const pieChartOptions: Options = useMemo(
    () => ({
      chart: {
        type: 'pie',
        backgroundColor: 'transparent',
        height: belowBreakpoint('md') ? '100%' : 400,
      },
      title: {
        text: '',
      },
      plotOptions: {
        pie: {
          // slicedOffset: 10,
          // borderWidth: 6,
          // borderColor: '#161617 !important',
        },
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        borderRadius: 12,
        backgroundColor: 'var(--color-main-800)',
        borderWidth: 0,
        useHTML: true,
        style: { fontFamily: 'Carbon-Text' },
        formatter: function () {
          return (
            '<div class="grid gap-16 p-10 text-14 text-main-0 font-medium w-[230px]">' +
            '<div class="flex justify-between">' +
            '<span class="text-main-0/60">ID</span>' +
            data[this.point.index].strategy.idDisplay +
            '</div>' +
            '<div class="flex justify-between">' +
            '<span class="text-main-0/60">Pair</span>' +
            buildPairNameByStrategy(data[this.point.index].strategy) +
            '</div>' +
            '<div class="flex justify-between">' +
            '<span class="text-main-0/60">Share</span>' +
            buildPercentageString(data[this.point.index].share) +
            '</div>' +
            '<div class="flex justify-between">' +
            '<span class="text-main-0/60">Amount</span>' +
            buildAmountString(data[this.point.index].amount, token) +
            '</div>' +
            '<div class="flex justify-between">' +
            '<span class="text-main-0/60">Value</span>' +
            getUsdPrice(data[this.point.index].value) +
            '</div>' +
            '</div>'
          );
        },
      },
      series: [
        {
          type: 'pie',
          name: 'Share',
          size: '80%',
          innerSize: '80%',
          dataLabels: {
            enabled: false,
          },
          data: data.map((item, i) => ({
            name: item.strategy.idDisplay,
            y: item.share.toNumber(),
            color: getColorByIndex(i),
            borderColor: '#161617',
            index: i,
          })),
        },
      ],
    }),
    [belowBreakpoint, data, token],
  );

  return { pieChartOptions };
};
